import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { Event, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-pga-restant-pga-voorgaande-jaren',
  templateUrl: './pga-restant-pga-voorgaande-jaren.component.html',
  styleUrls: ['./pga-restant-pga-voorgaande-jaren.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class PgaRestantPgaVoorgaandeJarenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    private incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public restantPgaVoorgaandeJaren = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router:Router,private fb: FormBuilder) {
        this.restantPgaVoorgaandeJaren = this.fb.group({
            pgaRestantPgaVoorgaandeJaren:
                this.fb.array<OmschrijvingEnBedrag>([])
        })
    }

    get pgaRestantPgaVoorgaandeJaren(): FormArray {
        return this.restantPgaVoorgaandeJaren.get('pgaRestantPgaVoorgaandeJaren') as FormArray;
    }

    addRijRestantPgaVoorgaandeJaren(): void {
        this.pgaRestantPgaVoorgaandeJaren.push(this.createRestantPgaVoorgaandeJarenFormGroup()
        )
    }

    verwijderRijRestantPgaVoorgaandeJaren(index: number): void {
        this.pgaRestantPgaVoorgaandeJaren.removeAt(index);
        this.restantPgaVoorgaandeJaren.updateValueAndValidity()
        this.restantPgaVoorgaandeJaren.markAsDirty()
        this.saveForm()
    }



    createRestantPgaVoorgaandeJarenFormGroup(pga?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: pga ? 'Restant PGA voorgaande jaren' : 'Restant PGA voorgaande jaren',
            bedrag: pga ? pga.bedrag : undefined,
        } as OmschrijvingEnBedrag))
    }

    public ngOnInit(): void {
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.restantPgaVoorgaandeJaren.dirty;
  }

  private updateForm(): void {
        const restantPgaLijst = this.aangifte?.persoonsgebondenAftrek?.restantPgaVoorgaandeJaren || [];
        const formArray = this.restantPgaVoorgaandeJaren.get('pgaRestantPgaVoorgaandeJaren') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > restantPgaLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < restantPgaLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(restantPgaLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createRestantPgaVoorgaandeJarenFormGroup(restantPgaLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    restantPgaVoorgaandeJaren: this.restantPgaVoorgaandeJaren.value.pgaRestantPgaVoorgaandeJaren
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }
}
